export var FeaturesEvent;
(function (FeaturesEvent) {
    FeaturesEvent["UserRolesChanged"] = "UserRolesChanged";
    FeaturesEvent["FeaturesAvailabilityChanged"] = "Features:FeaturesAvailabilityChanged";
    FeaturesEvent["DidPurchaseSubscription"] = "DidPurchaseSubscription";
})(FeaturesEvent || (FeaturesEvent = {}));
